import * as React from 'react'
import { getAllAgeRangeOptions } from '../../../util/ageRanges'

interface Props {
  selectedAgeRanges: string[]
  handleToggle: React.ChangeEventHandler<HTMLInputElement>
}

const FilterByAgeRange: React.FC<Props> = ({ selectedAgeRanges, handleToggle }) => {
  const ageRangeOptions = getAllAgeRangeOptions()

  return (
    <div className="filter-widget">
      <h1 className="widget-heading">Filter By Age Range</h1>
      {ageRangeOptions.map((option, index) => {
        const idName = `age-range-switch-${index + 1}`
        const ageRangeValue = option.value

        return (
          <dl key={ageRangeValue} className="slide-toggle">
            <dt className="onoffswitch">
              <input
                type="checkbox"
                name={ageRangeValue}
                className="onoffswitch-checkbox"
                id={idName}
                onChange={handleToggle}
                checked={selectedAgeRanges.includes(ageRangeValue)}
              />
              <label className="onoffswitch-label" htmlFor={idName} />
            </dt>
            <dd>{option.label}</dd>
          </dl>
        )
      })}
    </div>
  )
}

export default FilterByAgeRange